<bit-chip-content [startIcon]="startIcon()" [size]="baseChip.size()">
  {{ label() }}
</bit-chip-content>
